import type { ReactNode } from 'react'
import React, { forwardRef } from 'react'
import type { IconComponent } from '../../common/Icon'
import { Icon } from '../../common/Icon'
import { Loader } from '../../common/Loader'
import * as S from './styled'

type Size = 'medium' | 'large'
type Orientation = 'vertical' | 'horizontal'

type UploadAreaProps = {
  children: ReactNode
}

const UploadArea = forwardRef<HTMLDivElement, UploadAreaProps>(({ children, ...props }, ref) => {
  return (
    <S.ContentContainer ref={ref} {...props}>
      {children}
    </S.ContentContainer>
  )
})

type UploadAreaContentWrapperProps = {
  children: ReactNode
  accepted: boolean
  rejected: boolean
  invalid: boolean
  disabled?: boolean
  size: Size
}

export const UploadAreaContentWrapper = ({
  children,
  accepted,
  rejected,
  invalid,
  disabled = false,
  size,
}: UploadAreaContentWrapperProps) => {
  return (
    <S.DefaultContentContainer
      $accepted={accepted}
      $rejected={rejected}
      $invalid={invalid}
      $disabled={disabled}
      $size={size}
    >
      {children}
      <S.DefaultContentContainerBackground />
    </S.DefaultContentContainer>
  )
}

type UploadAreaLoaderProps = {
  size: Size
  orientation: Orientation
}

export const UploadAreaLoader = ({ size, orientation }: UploadAreaLoaderProps) => {
  return (
    <S.LoaderContainer>
      <S.Headline $size={size} $orientation={orientation}>
        Uploading...
      </S.Headline>
      <Loader />
    </S.LoaderContainer>
  )
}

type UploadAreaHeadlineProps = {
  size: Size
  orientation: Orientation
  children: ReactNode | undefined
}

export const UploadAreaHero = ({ orientation, size, children }: UploadAreaHeadlineProps) => {
  return (
    <S.Headline $orientation={orientation} $size={size}>
      {children}
    </S.Headline>
  )
}

type UploadAreaIconProps = {
  orientation: Orientation
  iconSize: number
  icon: IconComponent
}

export const UploadAreaIcon = ({ orientation, icon, iconSize }: UploadAreaIconProps) => {
  return (
    <S.IconContainer $orientation={orientation}>
      <Icon component={icon} height={iconSize} />
    </S.IconContainer>
  )
}

export {
  UploadArea as Root,
  UploadAreaContentWrapper as ContentWrapper,
  UploadAreaLoader as Loader,
  UploadAreaHero as Hero,
  UploadAreaIcon as HeroIcon,
}
